export const blockIconsCommunicationInventory2New = (
	<span className='material-symbols-outlined'>inventory_2</span>
);
